import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../../orpc'

export function useCrewGetMe() {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.crew.getMe.queryOptions(),
    retry: false,
  })
}

export function useCrewGetAll(filters?: {
  documentStatus?: 'valid' | 'expiring' | 'expired'
  role?: string
  base?: string
  query?: string
  includeDeleted?: boolean
}) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(
    orpc.crew.getAll.queryOptions({
      input: filters ?? {},
    })
  )
}

export function useCrewGetById(id: string | null) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({ ...orpc.crew.getById.queryOptions({ input: { id }, enabled: !!id }), refetchOnMount: 'always' })
}

export function useCrewGetByIds(ids: string[] | null | []) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.crew.getByIds.queryOptions({ input: { ids }, enabled: (!!ids) }))
}

export function useCrewGetBySupabaseUserId(supabaseUserId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.crew.getBySupabaseUserId.queryOptions({ input: { supabaseUserId } }))
}


export function useCrewGetPending() {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(orpc.crew.getPending.queryOptions())
}
